"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncReportResponseToJSON = exports.AsyncReportResponseFromJSONTyped = exports.AsyncReportResponseFromJSON = exports.instanceOfAsyncReportResponse = void 0;
var runtime_1 = require("../runtime");
var AsyncReportStatus_1 = require("./AsyncReportStatus");
/**
 * Check if a given object implements the AsyncReportResponse interface.
 */
function instanceOfAsyncReportResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAsyncReportResponse = instanceOfAsyncReportResponse;
function AsyncReportResponseFromJSON(json) {
    return AsyncReportResponseFromJSONTyped(json, false);
}
exports.AsyncReportResponseFromJSON = AsyncReportResponseFromJSON;
function AsyncReportResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, AsyncReportStatus_1.AsyncReportStatusFromJSON)(json['status']),
        'submittedAt': !(0, runtime_1.exists)(json, 'submitted_at') ? undefined : (new Date(json['submitted_at'])),
        'completedAt': !(0, runtime_1.exists)(json, 'completed_at') ? undefined : (new Date(json['completed_at'])),
        'reportUrl': !(0, runtime_1.exists)(json, 'report_url') ? undefined : json['report_url'],
    };
}
exports.AsyncReportResponseFromJSONTyped = AsyncReportResponseFromJSONTyped;
function AsyncReportResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': (0, AsyncReportStatus_1.AsyncReportStatusToJSON)(value.status),
        'submitted_at': value.submittedAt === undefined ? undefined : (value.submittedAt.toISOString()),
        'completed_at': value.completedAt === undefined ? undefined : (value.completedAt.toISOString()),
        'report_url': value.reportUrl,
    };
}
exports.AsyncReportResponseToJSON = AsyncReportResponseToJSON;
